<script context="module" lang="ts">
    import type { Load } from '@sveltejs/kit';

    export const load: Load = async ({ stuff }) => {
        const query = await stuff.cms.imprint();
        return {
            props: {
                query,
            },
        };
    };
</script>

<script lang="ts">
    import type { ImprintQuery } from '$gen/graphql';
    import SeoMetaTags from '$lib/components/SeoMetaTags.svelte';

    export let query: ImprintQuery;

    $: content = query?.entry?.__typename === 'imprint_imprint_Entry' ? query.entry : null;
</script>

{#if content}
    <SeoMetaTags seo={content.seo} />
    <section
        class="redactor mt-5 min-h-screen max-w-[100vw] space-y-5 overflow-hidden text-xl leading-5 md:text-2xl md:leading-6"
    >
        {@html content.redactor}
    </section>
{/if}

<style>
    .redactor :global(*) {
        white-space: pre-line;
    }
</style>
